import React from "react";
import { useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditProject from "../../components/projects/FormAddEditProject";

const CreateProject = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/projects");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditProject
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreateProject;